var React = require('react');

function Success (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#ffca08","d":"M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"}));
}

Success.defaultProps = {"width":"70","height":"70","viewBox":"0 0 24 24"};

module.exports = Success;

Success.default = Success;
